<script setup lang="ts">
import emptyState from '../../assets/visual/ds-visual-empty-state.svg'
import welcomeState from '../../assets/visual/ds-visual-welcome-state.svg'
import upSellState from '../../assets/visual/ds-visual-up-sale-state.svg'
import notReadyYetState from '../../assets/visual/ds-visual-not-ready-yet-state.svg'
import DsVisualEmptyState from './DsVisualEmptyState.vue'
import DsVisualUpSell from './DsVisualUpSell.vue'
import { PVisualType, PVisualVariant } from './types'

const visuals: Record<PVisualType, string> = {
  [PVisualType.EMPTY]: emptyState,
  [PVisualType.WELCOME]: welcomeState,
  [PVisualType.UP_SELL]: upSellState,
  [PVisualType.NOT_READY_YET]: notReadyYetState,
}

type Props = {
  title?: null | string
  description?: null | string

  /** Which illustration to show (any layout). */
  visual?: PVisualType
  /** Which layout to render. */
  variant?: PVisualVariant

  /** UP_SELL layout only */
  cardTitle?: null | string
  /** UP_SELL layout only */
  secondaryDescription?: null | string

  primaryBtn?: null | string
  primaryBtnIcon?: null | string
  secondaryBtn?: null | string
  secondaryBtnIcon?: null | string

  /** UP_SELL layout only */
  footerTitle?: null | string
}

type Emits = {
  (e: 'primary', evt: Event): void
  (e: 'secondary', evt: Event): void
}

withDefaults(defineProps<Props>(), {
  visual: PVisualType.EMPTY,
  variant: PVisualVariant.EMPTY_STATE,
})

const emits = defineEmits<Emits>()
</script>

<template>
  <ds-visual-up-sell
    v-if="variant === PVisualVariant.UP_SELL"
    :image="visuals[visual]"
    :title="title"
    :description="description"
    :card-title="cardTitle"
    :secondary-description="secondaryDescription"
    :primary-btn="primaryBtn"
    :primary-btn-icon="primaryBtnIcon"
    :secondary-btn="secondaryBtn"
    :secondary-btn-icon="secondaryBtnIcon"
    :footer-title="footerTitle"
    @primary="(e: Event) => emits('primary', e)"
    @secondary="(e: Event) => emits('secondary', e)"
  >
    <template #card>
      <slot name="card" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </ds-visual-up-sell>

  <ds-visual-empty-state
    v-else
    :image="visuals[visual]"
    :title="title"
    :description="description"
    :primary-btn="primaryBtn"
    :primary-btn-icon="primaryBtnIcon"
    :secondary-btn="secondaryBtn"
    :secondary-btn-icon="secondaryBtnIcon"
    @primary="(e: Event) => emits('primary', e)"
    @secondary="(e: Event) => emits('secondary', e)"
  />
</template>
